import {
    FETCH_PARTNER_SUCCESS,
    FETCH_PARTNER_FAILURE,
    SET_PAGINATION_META,
    SET_PARTNER_CUSTOMER,
    SET_VIEW_MODE,
    SET_SELECTED_CUSTOMER_ID,
    FETCH_DATA_FAILURE,
    FETCH_DATA_REQUEST,
    FETCH_DATA_SUCCESS,
    RESET_DATA,
    SET_SIDEBAR_LIST_ITEM,
    SET_PARTNER_CUSTOMER_COUNT
} from '../actions/actions'

const savedCustomer = JSON.parse(localStorage.getItem('partnerCustomer') || '{}');
const savedViewmode = localStorage.getItem('viewMode')

const initialState = {
    partnerCustomer: {
        name: savedCustomer.name || '',
        customerId: savedCustomer.customerId || null,
        dropdownItems: [],
        items: [],
        currentPage: 1,
        hasMore: true,
        loading: true,
        initialLoader: true,
        error: null,
        counts: {
            customers: 0,
            support_users: 0,
            iu_Consumed: 0,
            licenses: 0
        },
    },
    selectedCustomerId: '',
    viewMode: savedViewmode || '',
    sideBarlistItemId: null,
    paginationMeta: {
        currentPage: 1,
        totalPages: 0,
        totalItems: 0,
        pageSize: 10,
    },
};
export default function partnerReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_PARTNER_SUCCESS:
            return {
                ...state,
                partnersData: action.payload,
                error: action.payload,
            };
        case FETCH_PARTNER_FAILURE:
            return {
                ...state,
                partnersData: action.payload,
            };
        case SET_PAGINATION_META:
            return {
                ...state,
                paginationMeta: action.payload,
            };
        case SET_PARTNER_CUSTOMER:
            localStorage.setItem('partnerCustomer', JSON.stringify(action.payload));
            return {
                ...state,
                partnerCustomer: {
                    ...state.partnerCustomer,
                    name: action.payload.name,
                    customerId: action.payload.customerId,
                },

            };
        case SET_PARTNER_CUSTOMER_COUNT:
            return {
                ...state,
                partnerCustomer: {
                    ...state.partnerCustomer,
                    counts: {
                        customers: action.payload.counts.customers,
                        support_users: action.payload.counts.support_users,
                        iu_Consumed: action.payload.counts["IU Consumed"],
                        licenses: action.payload.counts.Licenses
                    }
                },

            };
        case SET_VIEW_MODE:
            return {
                ...state,
                viewMode: action.payload
            };
        case SET_SELECTED_CUSTOMER_ID:
            return {
                ...state,
                selectedCustomerId: action.payload
            };
        case SET_SIDEBAR_LIST_ITEM:
            return {
                ...state,
                sideBarlistItemId: action.payload
            };
        case FETCH_DATA_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_DATA_SUCCESS:
            const hasMore = !!action.payload.next;
            return {
                ...state,
                partnerCustomer: {
                    ...state.partnerCustomer,
                    loading: false,
                    initialLoader: false,
                    dropdownItems: [...new Map([...state.partnerCustomer.dropdownItems, ...action.payload.customers].map(x => [x.id, x])).values()],
                    items: [...state.partnerCustomer.items, ...action.payload.customers],
                    hasMore: hasMore,
                    currentPage: hasMore ? state.partnerCustomer.currentPage + 1 : state.partnerCustomer.currentPage
                },
            };
        case FETCH_DATA_FAILURE:
            return {
                ...state,
                partnerCustomer: {
                    ...state.partnerCustomer,
                    loading: false,
                    initialLoader: false, error: action.payload
                }
            };
        case RESET_DATA:
            return {
                ...state,
                partnerCustomer: {
                    ...state.partnerCustomer,
                    loading: false,
                    initialLoader: true,
                    items: [],
                    hasMore: false,
                    currentPage: 1
                },
            };;
        default:
            return state;
    }
}